import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, Router } from "@angular/router";
import { FrontendUrlsService } from "@shared-angular/services/frontend-urls.service";
import { LoginService, logout } from "@shared-angular/services/login.service";

export const portalLoginResolver: ResolveFn<void> = async (route: ActivatedRouteSnapshot) => {
  const loginService = inject(LoginService);
  const router = inject(Router);
  const frontendUrls = inject(FrontendUrlsService);

  const token = route.queryParamMap.get("token");
  if (!token) {
    throw new Error("no token provided as query param");
  }
  const deeplink = route.paramMap.get('deeplink');
  if (deeplink == "rag-admin") {
    // rag-admin has its own origin/localStorage, so it has to log in with the portal token itself.
    window.location.href = frontendUrls.ragAdmin("/de/rag-admin/portallogin?token=" + encodeURIComponent(token));
    return;
  }
  await loginService.loginByPortalToken(token);

  const user = await loginService.loadMyUser();

  if (user == null) {
    logout();
    return;
  }
  if (deeplink) {
    await router.navigate([deeplink]);
  } else {
    await router.navigate(['/admin/bot-admin']);
  }
};